(() => {
  'use strict';
  let pending = null, installed = false, busy = false, opener = null, previousOverflow = '';
  const standalone = window.matchMedia('(display-mode: standalone)');
  const buttons = () => Array.from(document.querySelectorAll('[data-ix-install]'));
  const sync = () => buttons().forEach(button => {
    button.hidden = installed || standalone.matches || navigator.standalone === true;
    button.disabled = busy;
  });
  window.addEventListener('beforeinstallprompt', event => {
    if (!event.isTrusted) return;
    event.preventDefault(); pending = event; sync();
  });
  window.addEventListener('appinstalled', event => {
    if (!event.isTrusted) return;
    installed = true; pending = null;
    const dialog = document.getElementById('ix-install-dialog');
    if (dialog?.open) dialog.close();
    sync();
  });
  const showHelp = () => {
    const dialog = document.getElementById('ix-install-dialog');
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    const help = dialog.querySelector('#ix-install-help');
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (help) help.textContent = ios ? help.dataset.ios : help.dataset.other;
    const preview = dialog.querySelector('[data-install-preview]');
    if (preview) preview.hidden = window.self === window.top;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ix-install]');
    if (!button || button.disabled || busy) return;
    event.preventDefault(); opener = button;
    if (!pending) { showHelp(); return; }
    const prompt = pending; pending = null; busy = true; sync();
    try { await prompt.prompt(); await prompt.userChoice; }
    catch (_) { showHelp(); }
    finally { busy = false; sync(); }
  });
  const ready = () => {
    const dialog = document.getElementById('ix-install-dialog');
    if (dialog) {
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        if (opener?.isConnected && !opener.hidden) opener.focus({preventScroll:true});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
    }
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true}); else ready();
  document.addEventListener('shopify:section:load', sync);
  standalone.addEventListener('change', sync);
})();
